// Paket düzenleyici yüklenirken iskelet (P3): başlık + arama + ağaç satırı yer tutucuları. Yerleşim
// gerçek düzenleyiciyle aynı akışta kalır (içerik yüklenince zıplama yok); ekran okuyucuya tek durum
// metni (`role=status`), görsel bloklar gizli. Hareket yok (app UI'da kabul).
import { KPI_PACKAGES_COPY } from "../../lib/kpi-packages-copy";

const bar = (w: string, h = 14): React.CSSProperties => ({
  width: w,
  height: h,
  borderRadius: 6,
  background: "var(--color-border)",
});

export function PackageEditorSkeleton(): JSX.Element {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-label={KPI_PACKAGES_COPY.page.loading}
      data-testid="package-editor-skeleton"
      className="flex flex-col gap-3"
    >
      <div aria-hidden="true" style={bar("40%", 22)} />
      <div aria-hidden="true" style={bar("25%")} />
      <div aria-hidden="true" style={{ ...bar("100%", 40), marginTop: 8 }} />
      {Array.from({ length: 6 }, (_, i) => (
        <div
          key={i}
          aria-hidden="true"
          className="flex items-center gap-3"
          style={{ minHeight: 40, paddingLeft: i % 3 === 0 ? 0 : 22 }}
        >
          <div style={{ ...bar("16px", 16), flexShrink: 0 }} />
          <div style={bar(`${(70 - (i % 3) * 12).toString()}%`)} />
        </div>
      ))}
    </div>
  );
}
